module.exports = __webpack_public_path__ + "img/accessory_pants_06.c37370a4.svg";